export class RecorderIsEnabledWhenConfiguring extends Error {
  constructor(message: string) {
    super(message)
    Object.setPrototypeOf(this, RecorderIsEnabledWhenConfiguring.prototype)
  }
}
